import { FC, ReactNode } from 'react'
import * as styles from 'components/features/pfm/SidebarPopup/SidebarPopupHeader.styl'

type SidebarPopupHeaderProps = {
  title: ReactNode
  left?: ReactNode
  right?: ReactNode
}

export const SidebarPopupHeader: FC<SidebarPopupHeaderProps> = (props) => {
  const { title, left, right } = props

  return (
    <header className={ styles.header }>
      <div className={ styles.headerLeft }>{ left }</div>
      <div className={ styles.headerTitle }>{ title }</div>
      <div className={ styles.headerRight }>{ right }</div>
    </header>
  )
}
